import { useState } from "react";
import type { DtoBorrower } from "@porchpass/api-client";
import { useWebClientApi } from "src/api";
import { useApiErrorHandler } from "./useApiErrorHandler";

interface UseGetBorrowerDataProps {
  dealerId: string;
  borrowerId: string;
}

export function useGetBorrowerData({
  dealerId: _dealerId,
  borrowerId,
}: UseGetBorrowerDataProps) {
  const api = useWebClientApi();
  const [borrowerData, setBorrowerData] = useState<DtoBorrower | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { handleApiError } = useApiErrorHandler();

  async function fetchBorrowerData() {
    if (!borrowerId) return;

    setIsLoading(true);
    setError(null);

    try {
      const data = await api.getBorrower(borrowerId);
      setBorrowerData(data);
    } catch (err) {
      console.error("Error fetching borrower data", err);
      setError(
        err instanceof Error ? err : new Error("Failed to fetch borrower data"),
      );
      handleApiError(
        err instanceof Error ? err : new Error("Failed to fetch borrower data"),
      );
    } finally {
      setIsLoading(false);
    }
  }

  return {
    borrowerData,
    isLoading,
    error,
    execute: fetchBorrowerData,
  };
}
